let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fV7Cf")).then(() => parcelRequire('gkSJt'));